import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, minimumRole = 'readOnly' }) {
  const { isAuthenticated, hasRole, loading } = useAuth();

  if (loading) {
    return <div className="loading">Laddar...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/styrelsen" replace />;
  }

  if (!hasRole(minimumRole)) {
    return (
      <div style={{ padding: '3rem', textAlign: 'center' }}>
        <h2>Åtkomst nekad</h2>
        <p>Du har inte behörighet att se denna sida.</p>
      </div>
    );
  }

  return children;
}
